export default __webpack_public_path__ + "static/media/picturePlaceholder.7838ed24.svg";